import Vue from 'vue'
const variavelGlobal = Vue.observable({
  bloqueioEncerramentoSessaoPorInatividade: false,
  xOldValue: null,
  yOldValue: null
})

localStorage.setItem('ultimaAtualizacao', 0)
function atualizarContadorNoLocalStorage () {
  const agora = Date.now();

  if (agora - localStorage.getItem('ultimaAtualizacao') >= 1000) {
    const valorAtual = parseInt(localStorage.getItem('contadorOperadorAusente')) || 0;
    localStorage.setItem('contadorOperadorAusente', valorAtual - 1);
    localStorage.setItem('ultimaAtualizacao', agora);
  }
}

export { variavelGlobal, atualizarContadorNoLocalStorage }
